module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN309_1498414555.8a44c9f9.png";